import Enumerator from '../global/Enumerator';

export const organizationTypes = ['root', 'group', 'branch', 'orphan'];

export class OrganizationType extends Enumerator {
  static default() {
    return this.of('orphan');
  }
}
OrganizationType.initEnum(organizationTypes);

export default {
  organizationTypes,
  OrganizationType
};
